"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecurrenceForm = void 0;
var React = require("react");
var mobx_react_1 = require("mobx-react");
var moment = require("moment");
var columns_1 = require("../columns");
var buttons_1 = require("../buttons");
var config_1 = require("../../config");
var App_1 = require("../../App");
var generic_1 = require("../generic");
var datepicker_1 = require("../datepicker");
var scopes;
(function (scopes) {
    scopes[scopes["DAILY"] = 10] = "DAILY";
    scopes[scopes["WEEKLY"] = 20] = "WEEKLY";
    scopes[scopes["MONTHLY"] = 30] = "MONTHLY";
    scopes[scopes["YEARLY"] = 40] = "YEARLY";
})(scopes || (scopes = {}));
var SmallInput = function (props) {
    return (React.createElement("input", { className: "SmallInput form-control", type: "number", name: props.name, value: props.value, onChange: props.onChange }));
};
var SmallSelect = function (props) {
    return (React.createElement("select", { name: props.name, value: props.value, onChange: props.onChange, className: "SmallSelect form-control" }, props.options.map(function (choice) {
        return React.createElement("option", { key: choice.value, value: choice.value }, choice.display_name);
    })));
};
var DailyForm = function (props) {
    return (React.createElement("div", { className: "RecurrenceForm__DailyForm" },
        React.createElement("label", null,
            React.createElement("input", { type: "radio", name: "dayChoice", checked: props.dayChoice === "1", value: "1", onChange: props.onChange }),
            pgettext("Every X day(s)", "Every"),
            "\u00A0",
            React.createElement(SmallInput, { name: "day_interval", value: props.day_interval, onChange: props.onChange }),
            pgettext("Every X day(s)", "Day(s)")),
        React.createElement("label", null,
            React.createElement("input", { type: "radio", name: "dayChoice", checked: props.dayChoice === "2", value: "2", onChange: props.onChange }),
            gettext("Every weekday"))));
};
var WeeklyForm = function (props) {
    return (React.createElement("div", { className: "RecurrenceForm__WeeklyForm" },
        pgettext("Recur every X weeks(s) on: [mon, tue, wed, ...,]", "Recur every"),
        "\u00A0",
        React.createElement(SmallInput, { name: "week_interval", value: props.week_interval, onChange: props.onChange }),
        "\u00A0",
        pgettext("Recur every X weeks(s) on: [mon, tue, wed, ...,]", "week(s) on"),
        ":",
        React.createElement("br", null),
        React.createElement("label", null,
            React.createElement("input", { type: "checkbox", name: "week_date_1", value: 10, checked: props.weekDays.indexOf(10) >= 0, onChange: props.onChange }),
            " ",
            gettext("Monday")),
        React.createElement("label", null,
            React.createElement("input", { type: "checkbox", name: "week_date_2", value: 20, checked: props.weekDays.indexOf(20) >= 0, onChange: props.onChange }),
            " ",
            gettext("Tuesday")),
        React.createElement("label", null,
            React.createElement("input", { type: "checkbox", name: "week_date_3", value: 30, checked: props.weekDays.indexOf(30) >= 0, onChange: props.onChange }),
            " ",
            gettext("Wednesday")),
        React.createElement("label", null,
            React.createElement("input", { type: "checkbox", name: "week_date_4", value: 40, checked: props.weekDays.indexOf(40) >= 0, onChange: props.onChange }),
            " ",
            gettext("Thursday")),
        React.createElement("label", null,
            React.createElement("input", { type: "checkbox", name: "week_date_5", value: 50, checked: props.weekDays.indexOf(50) >= 0, onChange: props.onChange }),
            " ",
            gettext("Friday")),
        React.createElement("label", null,
            React.createElement("input", { type: "checkbox", name: "week_date_6", value: 60, checked: props.weekDays.indexOf(60) >= 0, onChange: props.onChange }),
            " ",
            gettext("Saturday")),
        React.createElement("label", null,
            React.createElement("input", { type: "checkbox", name: "week_date_7", value: 70, checked: props.weekDays.indexOf(70) >= 0, onChange: props.onChange }),
            " ",
            gettext("Sunday"))));
};
var MonthlyForm = function (props) {
    return (React.createElement("div", { className: "RecurrenceForm__MonthlyForm" },
        React.createElement("label", null,
            React.createElement("input", { type: "radio", name: "monthChoice", checked: props.monthChoice === "1", value: "1", onChange: props.onChange }),
            "\u00A0",
            pgettext("Day [number] X of every Y month(s)", "Day"),
            "\u00A0",
            React.createElement(SmallInput, { name: "month_date", value: props.month_date, onChange: props.onChange }),
            "\u00A0",
            pgettext("Day [number] X of every Y month(s)", "of every"),
            "\u00A0",
            React.createElement(SmallInput, { name: "month_interval", value: props.month_interval, onChange: props.onChange }),
            "\u00A0",
            pgettext("Day [number] X of every Y month(s)", "month(s)"),
            "\u00A0"),
        React.createElement("label", null,
            React.createElement("input", { type: "radio", name: "monthChoice", checked: props.monthChoice === "2", value: "2", onChange: props.onChange }),
            "\u00A0",
            pgettext("The Xth [mon, tue, wed, ...,] of every Y month(s)", "The"),
            "\u00A0",
            React.createElement(SmallSelect, { name: "nth_match", value: props.nth_match, onChange: props.onChange, options: props.options.nth_match }),
            "\u00A0",
            React.createElement(SmallSelect, { value: props.day_of_week, name: "day_of_week", options: props.options.day_of_week, onChange: props.onChange }),
            "\u00A0",
            pgettext("The Xth [mon, tue, wed, ...,] of every Y month(s)", "of every"),
            "\u00A0",
            React.createElement(SmallInput, { name: "month_interval", value: props.month_interval, onChange: props.onChange }),
            "\u00A0",
            pgettext("The Xth [mon, tue, wed, ...,] of every Y month(s)", "month(s)"),
            "\u00A0")));
};
var YearlyForm = function (props) {
    return (React.createElement("div", { className: "RecurrenceForm__YearlyForm" },
        props.yearChoice == "1" ?
            pgettext("Recur every X year(s) on every [Jan, Feb, Mar, ...,] Yth", "Recur every")
            :
                pgettext("Recur every X year(s) on the Yth [mon, tue, wed, ...,] of [Jan, Feb, Mar, ...,]", "Recur every"),
        "\u00A0",
        React.createElement(SmallInput, { name: "year_interval", value: props.year_interval, onChange: props.onChange }),
        "\u00A0",
        props.yearChoice == "1" ?
            pgettext("Recur every X year(s) on every [Jan, Feb, Mar, ...,] Yth", "year(s)")
            :
                pgettext("Recur every X year(s) on the Yth [mon, tue, wed, ...,] of [Jan, Feb, Mar, ...,]", "year(s)"),
        ":\u00A0",
        React.createElement("label", null,
            React.createElement("input", { type: "radio", name: "yearChoice", checked: props.yearChoice === "1", value: "1", onChange: props.onChange }),
            "\u00A0",
            pgettext("Recur every X year(s) on every [Jan, Feb, Mar, ...,] Yth", "on every"),
            "\u00A0",
            React.createElement(SmallSelect, { value: props.year_month, name: "year_month", options: props.options.year_month, onChange: props.onChange }),
            "\u00A0",
            React.createElement(SmallInput, { name: "month_date", value: props.month_date, onChange: props.onChange }),
            "\u00A0"),
        React.createElement("label", null,
            React.createElement("input", { type: "radio", name: "yearChoice", checked: props.yearChoice === "2", value: "2", onChange: props.onChange }),
            "\u00A0",
            pgettext("Recur every X year(s) on the Yth [mon, tue, wed, ...,] of [Jan, Feb, Mar, ...,]", "on the"),
            "\u00A0",
            React.createElement(SmallSelect, { value: props.nth_match, name: "nth_match", options: props.options.nth_match, onChange: props.onChange }),
            "\u00A0",
            React.createElement(SmallSelect, { value: props.day_of_week, name: "day_of_week", options: props.options.day_of_week, onChange: props.onChange }),
            "\u00A0",
            pgettext("Recur every X year(s) on the Yth [mon, tue, wed, ...,] of [Jan, Feb, Mar, ...,]", "of"),
            "\u00A0",
            React.createElement(SmallSelect, { value: props.year_month, name: "year_month", options: props.options.year_month, onChange: props.onChange }),
            "\u00A0")));
};
var RecurrenceForm = (function (_super) {
    __extends(RecurrenceForm, _super);
    function RecurrenceForm(props) {
        var _this = _super.call(this, props) || this;
        _this.buildState(props);
        return _this;
    }
    RecurrenceForm.prototype.componentWillReceiveProps = function (nextProps) {
        this.buildState(nextProps);
    };
    RecurrenceForm.prototype.buildState = function (props) {
        var dayChoice = "1";
        var monthChoice = "1";
        var yearChoice = "1";
        if (props.recurrence) {
            var recurrence = props.recurrence;
            if (recurrence.scope_type === scopes.DAILY) {
                if (recurrence.day_interval !== null) {
                    dayChoice = "1";
                }
                else {
                    dayChoice = "2";
                }
            }
            else if (recurrence.scope_type === scopes.MONTHLY) {
                if (recurrence.month_date !== null) {
                    monthChoice = "1";
                }
                else {
                    monthChoice = "2";
                }
            }
            else if (recurrence.scope_type === scopes.YEARLY) {
                if (recurrence.year_month !== null) {
                    yearChoice = "1";
                }
                else {
                    yearChoice = "2";
                }
            }
        }
        this.state = {
            scope_type: props.recurrence ? props.recurrence.scope_type || scopes.DAILY : scopes.DAILY,
            dayChoice: dayChoice,
            day_interval: props.recurrence ? props.recurrence.day_interval || 1 : 1,
            week_interval: props.recurrence ? props.recurrence.week_interval || 1 : 1,
            weekDays: props.recurrence && props.recurrence.week_recur_days ? props.recurrence.week_recur_days.split(',').map(function (s) { return parseInt(s); }) || [] : [],
            monthChoice: monthChoice,
            month_date: props.recurrence ? props.recurrence.month_date || 1 : 1,
            month_interval: props.recurrence ? props.recurrence.month_interval || 1 : 1,
            nth_match: props.recurrence ? props.recurrence.nth_match || 10 : 10,
            day_of_week: props.recurrence ? props.recurrence.day_of_week || 10 : 10,
            yearChoice: yearChoice,
            year_interval: props.recurrence ? props.recurrence.year_interval || 1 : 1,
            year_month: props.recurrence ? props.recurrence.year_month || 1 : 1,
            deadline: props.control.deadline,
        };
    };
    RecurrenceForm.prototype.handleScopeChange = function (selectedScope) {
        this.setState({ scope_type: selectedScope });
    };
    RecurrenceForm.prototype.handleFormEvent = function (event) {
        var state = this.state;
        var target = event.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        var name = target.name;
        if (name.indexOf("week_date") >= 0) {
            var weekValue = parseInt(name[10]) * 10;
            var weekDays = state.weekDays;
            if (value) {
                weekDays.push(weekValue);
            }
            else {
                weekDays.splice(weekDays.indexOf(weekValue), 1);
            }
            var newState = {};
            newState[name] = weekDays;
            this.setState(newState);
        }
        else {
            var newState = {};
            newState[name] = value;
            this.setState(newState);
        }
    };
    RecurrenceForm.prototype.handleDisable = function () {
        App_1.store.controlDialog.deleteControlRecurrence();
    };
    RecurrenceForm.prototype.handleSubmit = function () {
        var props = this.props;
        var state = this.state;
        var recurrence = {
            scope_type: state.scope_type,
            day_interval: null,
            week_interval: null,
            week_recur_days: null,
            month_date: null,
            month_interval: null,
            nth_match: null,
            day_of_week: null,
            year_interval: null,
            year_month: null,
        };
        if (state.scope_type === scopes.DAILY) {
            if (state.dayChoice === "1") {
                recurrence.day_interval = state.day_interval;
            }
            else if (state.dayChoice === "2") {
                recurrence.week_interval = 1;
                recurrence.week_recur_days = "10,20,30,40,50";
                recurrence.scope_type = scopes.WEEKLY;
            }
        }
        else if (state.scope_type === scopes.MONTHLY) {
            if (state.monthChoice === "1") {
                recurrence.month_date = state.month_date;
                recurrence.month_interval = state.month_interval;
            }
            else if (state.monthChoice === "2") {
                recurrence.nth_match = state.nth_match;
                recurrence.day_of_week = state.day_of_week;
                recurrence.month_interval = state.month_interval;
            }
        }
        else if (state.scope_type === scopes.WEEKLY) {
            recurrence.week_interval = state.week_interval;
            recurrence.week_recur_days = state.weekDays.join(',');
        }
        else if (state.scope_type === scopes.YEARLY) {
            recurrence.year_interval = state.year_interval;
            if (state.yearChoice === "1") {
                recurrence.year_month = state.year_month;
                recurrence.month_date = state.month_date;
            }
            else if (state.yearChoice === "2") {
                recurrence.nth_match = state.nth_match;
                recurrence.day_of_week = state.day_of_week;
                recurrence.year_interval = state.year_interval;
            }
        }
        var control = {
            id: props.control.id,
            project: props.control.project,
            status: props.control.status,
            description: props.control.description,
            deadline: state.deadline,
            assigned_to: props.control.assigned_to,
        };
        props.onSubmit(control, recurrence);
    };
    RecurrenceForm.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var state = this.state;
        var daily = React.createElement(DailyForm, { onChange: this.handleFormEvent.bind(this), dayChoice: state.dayChoice, day_interval: state.day_interval });
        var weekly = React.createElement(WeeklyForm, { onChange: this.handleFormEvent.bind(this), options: props.recurrenceOptions, week_interval: state.week_interval, weekDays: state.weekDays });
        var monthly = React.createElement(MonthlyForm, { onChange: this.handleFormEvent.bind(this), options: props.recurrenceOptions, monthChoice: state.monthChoice, month_date: state.month_date, month_interval: state.month_interval, nth_match: state.nth_match, day_of_week: state.day_of_week });
        var yearly = React.createElement(YearlyForm, { onChange: this.handleFormEvent.bind(this), options: props.recurrenceOptions, yearChoice: state.yearChoice, year_interval: state.year_interval, month_date: state.month_date, day_of_week: state.day_of_week, nth_match: state.nth_match, year_month: state.year_month });
        var body = daily;
        switch (state.scope_type) {
            case scopes.DAILY:
                body = daily;
                break;
            case scopes.WEEKLY:
                body = weekly;
                break;
            case scopes.MONTHLY:
                body = monthly;
                break;
            case scopes.YEARLY:
                body = yearly;
                break;
            default: break;
        }
        var deadlineMoment = state.deadline ? moment(state.deadline) : null;
        return (React.createElement("div", { className: "RecurrenceForm" },
            React.createElement("div", { className: "RecurrenceForm__DateSelect" },
                React.createElement("label", null,
                    gettext("Starting from"),
                    ":\u00A0",
                    React.createElement(datepicker_1.default, { name: "deadline", selected: deadlineMoment, onChange: function (date) { return _this.setState({
                            deadline: date ? date.format(config_1.ISO_DATE_FORMAT) : null
                        }); } }))),
            React.createElement(generic_1.Clearfix, null),
            React.createElement("div", { className: "RecurrenceForm__ScopeSelect" },
                React.createElement("label", null,
                    React.createElement("input", { type: "radio", name: "scope", value: "".concat(scopes.DAILY), checked: state.scope_type === scopes.DAILY, onChange: function () { return _this.handleScopeChange(scopes.DAILY); } }),
                    gettext("Daily")),
                React.createElement("label", null,
                    React.createElement("input", { type: "radio", name: "scope", value: "".concat(scopes.WEEKLY), checked: state.scope_type === scopes.WEEKLY, onChange: function () { return _this.handleScopeChange(scopes.WEEKLY); } }),
                    gettext("Weekly")),
                React.createElement("label", null,
                    React.createElement("input", { type: "radio", name: "scope", value: "".concat(scopes.MONTHLY), checked: state.scope_type === scopes.MONTHLY, onChange: function () { return _this.handleScopeChange(scopes.MONTHLY); } }),
                    gettext("Monthly")),
                React.createElement("label", null,
                    React.createElement("input", { type: "radio", name: "scope", value: "".concat(scopes.YEARLY), checked: state.scope_type === scopes.YEARLY, onChange: function () { return _this.handleScopeChange(scopes.YEARLY); } }),
                    gettext("Yearly"))),
            React.createElement("div", { className: "RecurrenceForm__BodyWrapper" }, body),
            React.createElement(generic_1.Clearfix, null),
            React.createElement(columns_1.RightAlign, null,
                props.recurrence ?
                    React.createElement(buttons_1.Button, { onClick: this.handleDisable.bind(this) }, gettext("Disable recurrence"))
                    :
                        React.createElement("span", null,
                            gettext("Recurrence is not enabled"),
                            " \u00A0"),
                React.createElement(buttons_1.PrimaryButton, { onClick: this.handleSubmit.bind(this), className: "ml-1" }, props.recurrence ? gettext("Save") : gettext("Enable")))));
    };
    RecurrenceForm = __decorate([
        mobx_react_1.observer
    ], RecurrenceForm);
    return RecurrenceForm;
}(React.Component));
exports.RecurrenceForm = RecurrenceForm;
